// =============================================================================
// Title suggestions for the new-event form.
//
// As the user types a title, offer earlier events in the same calendar whose
// name matches, so a recurring appointment ("Physiotherapie", "Training") is
// two taps instead of a form. Picking one copies the *shape* of that event —
// label, all-day flag, times — onto the event being created. It never links
// to or edits the source: the result is a fresh event with its own id.
// =============================================================================

export const MAX_SUGGESTIONS = 5;

// Earlier events whose title contains `query` (case-insensitive), one per
// distinct title, most recently *dated* first so the times offered are the
// ones used last. Empty query → nothing, so the list only appears once the
// user has started typing.
export const suggestEvents = (events, query, limit = MAX_SUGGESTIONS) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return [];
  const seen = new Set();
  return [...(events || [])]
    .filter((ev) => (ev.title || '').toLowerCase().includes(q))
    .sort((a, b) => (b.date || '').localeCompare(a.date || ''))
    .filter((ev) => {
      const key = (ev.title || '').trim().toLowerCase();
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, limit);
};

// The fields a suggestion carries into the draft. Deliberately *not* the
// date, end date, recurrence, notes or participants: the user picked a day
// already, and copying a repeat rule or an invite list silently would be a
// nasty surprise.
export const applySuggestionTo = (draft, source) => ({
  ...draft,
  title: source.title,
  categoryId: source.categoryId || draft.categoryId,
  allDay: !!source.allDay,
  startTime: source.allDay ? '' : source.startTime || '',
  endTime: source.allDay ? '' : source.endTime || ''
});
